import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import NavBar from "./Components/Navbar/NavBar";
import Home from './Components/Home/Home';


import Movies from './Components/Movies/Movies';
import Series from './Components/Series/Series';
import MovieDetails from './Components/MovieDetails/MovieDetails';
import SeriesDetails from './Components/SeriesDetails/SeriesDetails';
import jwtDecode from "jwt-decode";

import People from "./Components/People/People";
import PeopleDetails from "./Components/PeopleDetails/PeopleDetails";
import Search from "./Components/Search/Search";
import TopRatedMovies from "./Components/TopRatedMovies/TopRatedMovies";
import TopRatedSeries from "./Components/TopRatedSeries/TopRatedSeries";





function App() {

  

  

  


  return <>
    <NavBar/>
    
      <Routes>
      <Route path="/" element={ <Home />} />
      <Route path="home" element={ <Home />} />
      <Route path="movies" element={ <Movies />}/>
      <Route path="topratedmovies" element={<TopRatedMovies/>}/>
      <Route path="topratedseries" element={<TopRatedSeries/>}/>
      <Route path="moviedetails" element={ <MovieDetails />}>
        <Route path=":id" element={ <MovieDetails />}/>
      </Route>
      <Route path="seriesdetails" element={ <SeriesDetails />}>
        <Route path=":id" element={ <SeriesDetails />} />
      </Route>
      <Route path="series" element={ <Series />} />
      <Route path="people" element={ <People />} />
      <Route path="search" element={ <Search />} />
      <Route path="peopledetails" element={ <PeopleDetails />}>
        <Route path=":id" element={ <PeopleDetails />} />
      </Route>
      <Route path="*" element={<div className="vh-100 d-flex align-items-center justify-content-center"><h1>404</h1></div>} />
    </Routes>
    







  </>
}

export default App;